import EmptyLineItems from './svg/line-items-empty.svg'

export default EmptyLineItems
